<ion-header class="ion-no-border">
  <ion-toolbar>

    <ng-container *ngIf="!isNativeApp">
      <ion-buttons slot="start" class="ion-hide-md-up">
        <ion-button color="secondary" (click)="toggleMobileMenu()" #mobileMenuToggle>
          <ion-icon slot="icon-only" [name]="isMobileMenuOpen ? 'close' : 'menu'"></ion-icon>
        </ion-button>
      </ion-buttons>

      <a slot="start" class="header-logo-link ion-hide-md-down" href="https://www.eugloh.eu/" target="_blank">
        <img src="assets/images/logos/EUGLOH_logo.png" alt="{{ 'EUGLOH_LOGO' | translate }}" class="header-logo">
      </a>
      <div class="mobile-logo-container ion-hide-md-up">
        <a href="https://www.eugloh.eu/" target="_blank">
          <img src="assets/images/logos/EUGLOH_logo.png" alt="{{ 'EUGLOH_LOGO' | translate }}"
            class="header-logo-mobile">
        </a>
      </div>

      <ion-buttons slot="start" class="ion-hide-md-down desktop-nav-buttons">
        <ion-button routerLink="/" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }"><span>{{
            'HOME' | translate }}</span></ion-button>

        <div class="dropdown-container" #dropdownContainer>
          <ion-button (click)="toggleOpportunities()" [class.active-link]="isOpportunitiesActive()">
            <span>{{ 'OPPORTUNITIES' | translate }}</span>
            <ion-icon slot="end"
              [name]="isOpportunitiesOpen ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
          </ion-button>
        </div>

        <ion-button routerLink="/expert-database" routerLinkActive="active-link"><span>{{ 'EXPERT_DATABASE' | translate
            }}</span></ion-button>
        <ion-button routerLink="/about" routerLinkActive="active-link"><span>{{ 'ABOUT' | translate
            }}</span></ion-button>

        <div class="dropdown-container" *ngIf="isAdmin$ | async" #adminMenuContainer>
          <ion-button (click)="toggleAdminMenu()" [class.active-link]="isAdminActive()">
            <span>{{ 'ADMIN' | translate }}</span>
            <ion-icon slot="end" [name]="isAdminMenuOpen ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
          </ion-button>
        </div>
      </ion-buttons>

      <ion-buttons slot="end">
        <div class="ion-hide-md-down">
          <ng-container *ngIf="(isLoggedIn$ | async); else loggedOut">
            <div class="user-menu-container" #userMenuContainer>
              <ion-button (click)="toggleUserMenu()" fill="clear" class="user-menu-trigger" aria-label="User menu"
                color="dark">
                <ion-icon name="person-outline" color="primary"></ion-icon>
                <span class="session-time">({{ remainingTime$ | async }})</span>
              </ion-button>
            </div>
          </ng-container>
          <ng-template #loggedOut>
            <ion-button fill="solid" color="primary" (click)="openLoginModal()">
              {{ 'LOGIN' | translate }}
            </ion-button>
          </ng-template>
        </div>
      </ion-buttons>
    </ng-container>

    <ng-container *ngIf="isNativeApp">
      <div slot="start" class="app-logo-container">
        <a href="https://www.eugloh.eu/" target="_blank">
          <img src="assets/images/logos/EUGLOH_logo.png" alt="{{ 'EUGLOH_LOGO' | translate }}"
            class="header-logo-mobile">
        </a>
      </div>

      <ion-buttons slot="end">
        <ng-container *ngIf="(isLoggedIn$ | async); else appLoggedOut">
          <ion-button (click)="handleHeaderAction()" fill="clear" color="primary" class="mobile-header-btn">
            <ion-icon *ngIf="isOnProfilePage" name="log-out-outline" size="large"></ion-icon>
            <ion-icon *ngIf="!isOnProfilePage" name="person-circle-outline" size="large"></ion-icon>
          </ion-button>
        </ng-container>

        <ng-template #appLoggedOut>
          <ion-button (click)="openLoginModal()" fill="clear" color="primary" class="mobile-header-btn">
            <ion-icon name="log-in-outline" size="large"></ion-icon>
          </ion-button>
        </ng-template>
      </ion-buttons>
    </ng-container>

  </ion-toolbar>

  <div class="ion-hide-md-down" *ngIf="!isNativeApp">
    <div class="dropdown-menu" *ngIf="isOpportunitiesOpen"
      [ngStyle]="{'top.px': opportunitiesDropdownPosition.top, 'left.px': opportunitiesDropdownPosition.left}">
      <ion-item *ngFor="let sub of opportunityPages" (click)="navigateTo(sub.url, sub.filter)" button>
        <ion-label><span>{{ sub.title | translate }}</span></ion-label>
      </ion-item>
    </div>

    <div class="admin-dropdown-menu" *ngIf="isAdminMenuOpen"
      [ngStyle]="{'top.px': adminDropdownPosition.top, 'left.px': adminDropdownPosition.left}">
      <ion-item (click)="selectAdminSection()" button>
        <ion-label><span>{{ 'ADMIN_DASHBOARD' | translate }}</span></ion-label>
      </ion-item>
      <ion-item *ngFor="let section of availableAdminSections$ | async" (click)="selectAdminSection(section)" button>
        <span class="admin-icon" [innerHTML]="getAdminSectionIcon(section.name)"></span>
        <ion-label><span>{{ section.name === 'Super Admin' ? ('USER_DATA' | translate) : ('OPPORTUNITIES' | translate)
            }}</span></ion-label>
      </ion-item>
    </div>
  </div>

  <div class="user-dropdown-menu" *ngIf="isUserMenuOpen && !isNativeApp">
    <ion-list lines="none">
      <ion-item (click)="navigateTo('/profile')" button>
        <ion-label>{{ 'PROFILE' | translate }}</ion-label>
      </ion-item>
      <ion-item (click)="logout()" button>
        <ion-label>{{ 'LOGOUT' | translate }}</ion-label>
      </ion-item>
    </ion-list>
  </div>

  <div class="mobile-menu" [class.is-open]="isMobileMenuOpen" #mobileMenu *ngIf="!isNativeApp">
    <div class="mobile-menu-content">
      <ion-list lines="none">
        <ion-item routerLink="/" routerLinkActive="mobile-active-link" [routerLinkActiveOptions]="{ exact: true }"
          (click)="navigateTo('/')" button>
          <ion-label><span>{{ 'HOME' | translate }}</span></ion-label>
        </ion-item>

        <ion-item (click)="toggleOpportunities()" button detail="false" #mobileOpportunitiesToggle
          [class.mobile-active-link]="isOpportunitiesActive()">
          <ion-label><span>{{ 'OPPORTUNITIES' | translate }}</span></ion-label>
          <ion-icon slot="end" [name]="isOpportunitiesOpen ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
        </ion-item>
        <div *ngIf="isOpportunitiesOpen" class="nested-mobile-list">
          <ion-item *ngFor="let sub of opportunityPages" (click)="navigateTo(sub.url, sub.filter)" button>
            <ion-label><span>{{ sub.title | translate }}</span></ion-label>
          </ion-item>
        </div>

        <ion-item routerLink="/expert-database" routerLinkActive="mobile-active-link"
          (click)="navigateTo('/expert-database')" button>
          <ion-label><span>{{ 'EXPERT_DATABASE' | translate }}</span></ion-label>
        </ion-item>

        <ion-item routerLink="/about" routerLinkActive="mobile-active-link" (click)="navigateTo('/about')" button>
          <ion-label><span>{{ 'ABOUT' | translate }}</span></ion-label>
        </ion-item>

        <ng-container *ngIf="isAdmin$ | async">
          <ion-item (click)="toggleAdminMenu()" button detail="false" #mobileAdminToggle
            [class.mobile-active-link]="isAdminActive()">
            <ion-label><span>{{ 'ADMIN' | translate }}</span></ion-label>
            <ion-icon slot="end" [name]="isAdminMenuOpen ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
          </ion-item>
          <div *ngIf="isAdminMenuOpen" class="nested-mobile-list">
            <ion-item (click)="selectAdminSection()" button>
              <ion-label><span>{{ 'ADMIN_DASHBOARD' | translate }}</span></ion-label>
            </ion-item>
            <ion-item *ngFor="let section of availableAdminSections$ | async" (click)="selectAdminSection(section)"
              button>
              <ion-label><span>{{ section.name === 'Super Admin' ? ('USER_DATA' | translate) : ('OPPORTUNITIES' |
                  translate) }}</span></ion-label>
            </ion-item>
          </div>
        </ng-container>

        <ng-container *ngIf="(isLoggedIn$ | async); else mobileLoggedOut">
          <ion-item (click)="navigateTo('/profile')" button>
            <ion-label><span>{{ 'PROFILE' | translate }}</span></ion-label>
          </ion-item>
          <ion-item (click)="logout()" button>
            <ion-label><span>{{ 'LOGOUT' | translate }}</span></ion-label>
          </ion-item>
        </ng-container>
        <ng-template #mobileLoggedOut>
          <ion-item (click)="openLoginModal()" button>
            <ion-label><span>{{ 'LOGIN' | translate }}</span></ion-label>
          </ion-item>
        </ng-template>
      </ion-list>
    </div>
  </div>
</ion-header>